<template>
  <div>
    <van-nav-bar left-text="" :title="name" left-arrow :border="false" class="custom-nav-bar" >
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="p-[10px] w-full">
      <div class="rich-content" v-html="info"></div>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { Button } from "@/components/Button"
const route = useRoute()
const router = useRouter()

const onClickLeft = () => {
  router.back()
}

const info = route.query.info
const name = route.query.name
console.log('接收到的info参数:', info)
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}

.rich-content {
  width: 100%;
  max-width: 100%;
  word-wrap: break-word;
  word-break: break-all;
  box-sizing: border-box;
  /* 移除 height 相关限制 */
}

.rich-content :deep(img) {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}

.rich-content :deep(video) {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}

.rich-content :deep(iframe) {
  max-width: 100% !important;
  height: auto !important;
  display: block;
  margin: 0 auto;
}

.rich-content :deep(table) {
  width: 100% !important;
  table-layout: fixed;
  word-wrap: break-word;
}

.rich-content :deep(p) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}

.rich-content :deep(div) {
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
